<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li class="flex items-center">
              <router-link to="/systemHooks" class="mr-2 vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
              <h3>{{ $t("system.label.CreateEventActionMapping") }}</h3>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.Event")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Event')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="createEventMap.event"
                    :options="eventList"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.Action")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Action')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="createEventMap.action"
                    :options="actionList"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.Process')"
              >
                <vs-input
                  :label="$t('system.label.Process')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="createEventMap.process"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.OrderBy")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.OrderBy')"
                >
                  <v-select
                    label="text"
                    v-model="createEventMap.orderBy"
                    :options="orderByList"
                    :reduce="(text) => text.value"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    class="w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.ExternalSystem")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ExternalSystem')"
                >
                  <v-select
                    label="text"
                    v-model="createEventMap.externalSystem"
                    :options="externalSystemData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    class="w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.PrePost")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.PrePost')"
                >
                  <v-select
                    label="text"
                    v-model="createEventMap.prePost"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :options="prePostShow"
                    :reduce="(text) => text.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                v-model="createEventMap.issynchronous"
                >{{ $t("system.label.isSynchronous") }}</vs-checkbox
              >
            </div>
            <div class="vx-col w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("system.label.ProcessParams")
                }}</small>

                <vs-textarea v-model="createEventMap.processParams" />
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="submitEventActionForm"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const createEventMapEmptyObj = {
  event: "",
  action: "",
  orderBy: "",
  prePost: "",
  issynchronous: false,
  processParams: "",
  externalSystem: "",
  process: "workflow_events",
};
export default {
  data() {
    return {
      breadcrumbs: [
        { name: "System", to: "" },
        { name: this.$t("system.label.Hooks"), to: "/systemHooks" },
        { name: this.$t("system.label.CreateEventActionMapping"), to: "/" },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      createEventMap: createEventMapEmptyObj,
      eventList: [],
      actionList: [],
      externalSystemData: [],
      orderByList: [
        { text: "0", value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
      ],
      prePostList: [],
      prePostShow: [
        { text: "Pre", value: false },
        { text: "Post", value: true },
      ],
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {},
  methods: {
    async getEventActionData() {
      try {
        const response = await this.$store.dispatch(
          "configuration/getCreateSetEventActionTemplate"
        );
        this.data = response.data;
        response.data.eventData.forEach((element) => {
          this.eventList.push(element.codeValue);
        });
        response.data.actionData.forEach((element) => {
          this.actionList.push(element.codeValue);
        });
        this.externalSystemData = response.data.externalSystemData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async submitEventActionForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        await this.$store.dispatch(
          "configuration/createEventActionmappingAction",
          this.createEventMap
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Event Action Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push("/systemHooks");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.createEventMap.event = null;
      this.createEventMap.action = null;
      this.createEventMap.orderBy = "";
      this.createEventMap.prePost = null;
      this.createEventMap.issynchronous = false;
      this.createEventMap.externalSystem = null;
      this.createEventMap.processParams = "";
    },
  },
  async mounted() {
    this.resetForm();
    await this.getEventActionData();
  },
};
</script>
